import { useEffect, useState } from "react";
import Paginator from "../../shared/Paginator";
import API from "../../services/api";
import { toLakhs } from "../../utils/constants";

const BirdviewSummary = ({category_ids,locations, brand_type, ad_type, showSummary, search, dateRange, selectedNewspaper, selectedCategory, selectedSubCategory }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!showSummary) {
      return;
    }
    const getAlphaData = async () => {
        const response = await API({
            url: `/birdview/getBirdviewSummary`,
            method: "POST",
            responseType: "json",
            data: {
                dateRange,
                search: search,
                category_id: selectedCategory?.value,
                sub_category_id: selectedSubCategory?.value,
                page: currentPage,
                limit: 10,
                ad_type,
                newspapers: selectedNewspaper.length ? selectedNewspaper.map((item) => item.value) : [],
                category_ids : category_ids,
                brand_type,
                locations,
            },
        });

        if (response?.code === 200) {
            setData(response.data);
            setTotalPages(Math.ceil(response.data.totalPages/10));
        }
    };

    getAlphaData();
    }, [currentPage, showSummary, search, dateRange, selectedNewspaper, selectedCategory, selectedSubCategory, ad_type]);

  if (!showSummary) {
    return null;
  }
  return (
    <div className="w-full h-full">
        <div className="w-full bg-white">
        <table className="bg-white z-50 table table-bordered">
            <thead>
            <tr>
                <th>Date</th>
                <th>Ad Format</th>
                <th title={data?.total_count}>Count {` ( ${data.total_count} )`}</th>
                <th title={data?.total_revenue}>Revenue {` ( ${toLakhs(data?.total_revenue)} )`}</th>
            </tr>
            </thead>

            <tbody>
            {data?.res?.map(item =>( 
                <tr>
                    <td>{item.date}</td>
                    <td><div className="flex gap-1 flex-wrap">{item.ad_formats?.map((f, i) => ( <span key={i} className="px-2 py-1 bg-gray-200 rounded text-xs"> {f} </span> ))}</div></td>
                    <td>{item.count}</td>
                    <td>{item.revenue}</td>
                </tr>
            ))}
            </tbody>
        </table>
        <Paginator pageCount={totalPages} forcePage={currentPage} handlePageClick={(event) => setCurrentPage(event.selected)} />
        </div>
    </div>
  );
};

export default BirdviewSummary;
